<template>
  <div v-if="isWishListTicketLoading" class="wish-list-contents__container">
    <div class="wish-list-contents__loading">
      <SmallLoading />
    </div>
  </div>
  <div v-else class="wish-list-contents__container">
    <WishListContentHeaderForOtherUser
      :is-wish-list-item-present="isWishListItemPresent"
      :nickname="nickname"
    />
    <div class="wish-list-contents__empty-body">
      <div class="wish-list-contents__for-other-user">
        ほしいものが登録されていません
      </div>
    </div>
  </div>
</template>

<script>
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'
import WishListContentHeaderForOtherUser from '../../../organism/mypages/profiles/WishListContentHeaderForOtherUser.vue'

export default {
  components: {
    SmallLoading,
    WishListContentHeaderForOtherUser
  },
  props: {
    isWishListTicketLoading: {
      type: Boolean,
      require: false,
      default: false
    },
    isWishListItemPresent: {
      type: Boolean,
      require: false,
      default: false
    },
    nickname: {
      type: String,
      require: false,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-contents {
  &__container {
    margin: 0 auto;
    padding: 0;
    background-color: $white;
  }

  &__loading {
    margin: auto;
    padding: 24px;
  }

  &__empty-body {
    margin: auto;
    text-align: center;
    max-width: $small-contents-width;
    padding: 0 16px 24px;
  }

  &__for-other-user {
    font-size: 1.4rem;
    line-height: 1.6;
    color: $gray-1;
  }
}
</style>
